






















import Vue                      from 'vue'
import {Component, Model, Prop} from 'vue-property-decorator'
import {prop}                   from '@/common/helpers'

@Component
export default class CustomInput extends Vue {
    @Prop(prop(String, 'text'))
    protected type!: string

    @Prop(String)
    protected placeholder!: string

    @Prop(Boolean)
    protected required!: boolean

    @Prop(Boolean)
    protected autofocus!: boolean

    @Prop(Boolean)
    protected textCenter!: boolean

    @Prop([String, Array])
    protected mask!: string | string[]

    @Model('change', String)
    protected value!: string
}
